import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Button, Badge } from "react-bootstrap";
import { FaShoppingCart, FaUser, FaTimes, FaSignInAlt, FaUserPlus, FaCog } from "react-icons/fa";
import { connect } from 'react-redux';
import { updateCart } from '../../redux/actions/cartActions';
import "bootstrap/dist/css/bootstrap.min.css";

const Header = ({ cartItemCount, updateCart }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const storedUsername = localStorage.getItem("username");
    setIsAuthenticated(!!token);
    setUsername(storedUsername || "");

    const cartItems = JSON.parse(localStorage.getItem("cart") || "[]");
    updateCart(cartItems);

    setExpanded(false);
  }, [location, updateCart]);

  const handleLogout = () => {
    const isKakao = localStorage.getItem("isKakao") === "true";
    if (isKakao && window.Kakao && window.Kakao.Auth) {
      window.Kakao.Auth.logout(() => {
        console.log("카카오 로그아웃 완료");
      });
    }
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("username");
    localStorage.removeItem("isKakao");
    setIsAuthenticated(false);
    setUsername("");
    setExpanded(false);
    navigate("/");
  };

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <header className="header">
      <Navbar
        expand="lg"
        className="py-2"
        style={{ backgroundColor: "#009590" }}
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" onClick={handleNavClick}>
            <img
              src="/images/logo.svg"
              alt="로고"
              height="50"
              className="img-fluid"
              style={{ marginRight: "15px" }}
            />
            <span
              style={{
                color: "white",
                fontWeight: "600",
                fontSize: "1.5rem",
                letterSpacing: "0.5px",
              }}
            >
              비나이다
            </span>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="border-0"
            style={{ backgroundColor: "rgba(255,255,255,0.8)" }}
          />

          <Navbar.Collapse id="basic-navbar-nav">
            {/* 모바일에서 햄버거 열렸을 때만 표시하는 헤더 */}
            {expanded && (
              <div className="d-lg-none mobile-menu-header">
                <div className="d-flex justify-content-between align-items-center px-3 py-3">
                  <div className="user-greeting">
                    {isAuthenticated ? (
                      <span className="text-white fw-medium d-inline-block">
                        {username
                          ? `${/^\d+$/.test(username) ? "사용자" : username}님 환영합니다`
                          : "환영합니다"}
                      </span>
                    ) : (
                      <span className="text-white-50">로그인하세요</span>
                    )}
                  </div>
                  <Button
                    variant="link"
                    onClick={() => setExpanded(false)}
                    className="p-0 text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <FaTimes size={22} />
                  </Button>
                </div>
              </div>
            )}

            {/* 모바일 전용 메뉴 - 큰 화면에서는 숨김 */}
            <Nav className="mobile-nav mx-auto d-lg-none">
              {[
                { title: "소개", path: "/about", icon: null },
                { title: "공양", path: "/pray", icon: null },
                { title: "온라인 법당", path: "/sanctuary", icon: null },
                { title: "불교 모임", path: "/community", icon: null },
                { title: "소원기도", path: "/live", icon: null },
                { title: "불교 달력", path: "/buddhist-calendar", icon: null },
                { title: "공지사항", path: "/notice", icon: null },
                { title: "Q&A", path: "/qna", icon: null },
              ].map((item, index) => (
                <Nav.Link
                  key={index}
                  as={Link}
                  to={item.path}
                  onClick={handleNavClick}
                  className="mobile-menu-item"
                >
                  <span>{item.title}</span>
                </Nav.Link>
              ))}
              
              {/* 장바구니 메뉴 - 모바일 전용 */}
              <Nav.Link
                as={Link}
                to="/cart"
                onClick={handleNavClick}
                className="mobile-menu-item"
              >
                <div className="d-flex align-items-center">
                  <div className="menu-icon-container">
                    <FaShoppingCart size={18} />
                    {cartItemCount > 0 && (
                      <Badge
                        pill
                        bg="danger"
                        className="mobile-menu-badge"
                      >
                        {cartItemCount}
                      </Badge>
                    )}
                  </div>
                  <span className="ms-3">장바구니</span>
                </div>
              </Nav.Link>
              
              {/* 마이페이지 (로그인 시에만) - 모바일 전용 */}
              {isAuthenticated && (
                <Nav.Link
                  as={Link}
                  to="/mypage"
                  onClick={handleNavClick}
                  className="mobile-menu-item"
                >
                  <div className="d-flex align-items-center">
                    <div className="menu-icon-container">
                      <FaUser size={18} />
                    </div>
                    <span className="ms-3">마이페이지</span>
                  </div>
                </Nav.Link>
              )}
              
              {/* 관리자 메뉴 (로그인 시에만) - 모바일 전용 */}
              {isAuthenticated && (
                <Nav.Link
                  as={Link}
                  to="/admin/temples"
                  onClick={handleNavClick}
                  className="mobile-menu-item"
                >
                  <div className="d-flex align-items-center">
                    <div className="menu-icon-container">
                      <FaCog size={18} />
                    </div>
                    <span className="ms-3">관리자 메뉴</span>
                  </div>
                </Nav.Link>
              )}

              {/* 모바일에서 로그인/회원가입 버튼 */}
              <div className="mobile-auth-section">
                {!isAuthenticated ? (
                  <>
                    <Nav.Link
                      as={Link}
                      to="/login"
                      onClick={handleNavClick}
                      className="mobile-menu-item login-item"
                    >
                      <div className="d-flex align-items-center">
                        <div className="menu-icon-container">
                          <FaSignInAlt size={18} />
                        </div>
                        <span className="ms-3">로그인</span>
                      </div>
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/register"
                      onClick={handleNavClick}
                      className="mobile-menu-item signup-item"
                    >
                      <div className="d-flex align-items-center">
                        <div className="menu-icon-container">
                          <FaUserPlus size={18} />
                        </div>
                        <span className="ms-3">회원가입</span>
                      </div>
                    </Nav.Link>
                  </>
                ) : (
                  <Nav.Link
                    onClick={() => {
                      handleLogout();
                      handleNavClick();
                    }}
                    className="mobile-menu-item logout-item"
                  >
                    <div className="d-flex align-items-center">
                      <div className="menu-icon-container">
                        <FaSignInAlt size={18} />
                      </div>
                      <span className="ms-3">로그아웃</span>
                    </div>
                  </Nav.Link>
                )}
              </div>
            </Nav>

            {/* 데스크탑 메뉴 - 작은 화면에서는 숨김 */}
            <Nav className="desktop-nav mx-auto d-none d-lg-flex flex-nowrap">
              {[
                { title: "소개", path: "/about" },
                { title: "공양", path: "/pray" },
                { title: "온라인 법당", path: "/sanctuary" },
                { title: "불교 모임", path: "/community" },
                { title: "소원기도", path: "/live" },
                { title: "불교 달력", path: "/buddhist-calendar" },
                { title: "공지사항", path: "/notice" },
                { title: "Q&A", path: "/qna" },
              ].map((item, index) => (
                <Nav.Link
                  key={index}
                  as={Link}
                  to={item.path}
                  onClick={handleNavClick}
                  className="nav-link-custom mx-1"
                  style={{
                    color: "white",
                    fontWeight: "500",
                    position: "relative",
                    fontSize: "0.9rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.title}
                </Nav.Link>
              ))}
            </Nav>

            {/* 데스크탑 우측 메뉴 - 작은 화면에서는 숨김 */}
            <Nav className="align-items-center d-none d-lg-flex flex-nowrap flex-shrink-0" style={{ marginLeft: "8px" }}>
              {/* 장바구니 아이콘 */}
              <Nav.Link
                as={Link}
                to="/cart"
                className="position-relative me-3"
                style={{ color: "white" }}
                onClick={handleNavClick}
              >
                <FaShoppingCart size={20} />
                {cartItemCount > 0 && (
                  <Badge
                    pill
                    bg="danger"
                    text="light"
                    className="position-absolute"
                    style={{
                      fontSize: "0.65rem",
                      padding: "0.15rem 0.35rem",
                      minWidth: "1rem",
                      height: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      top: "0px",
                      right: "0px",
                      borderRadius: "50%",
                      border: "1px solid white",
                    }}
                  >
                    {cartItemCount}
                  </Badge>
                )}
              </Nav.Link>
              
              {/* 마이페이지 아이콘 (로그인 시에만 표시) */}
              {isAuthenticated && (
                <Nav.Link
                  as={Link}
                  to="/mypage"
                  onClick={handleNavClick}
                  className="position-relative me-3"
                  style={{ color: "white" }}
                  title="마이페이지"
                >
                  <FaUser size={18} />
                </Nav.Link>
              )}
              
              {/* 관리자 메뉴 아이콘 (로그인 시에만 표시) */}
              {isAuthenticated && (
                <Nav.Link
                  as={Link}
                  to="/admin/temples"
                  onClick={handleNavClick}
                  className="position-relative me-3"
                  style={{ color: "white" }}
                  title="관리자 메뉴"
                >
                  <FaCog size={18} />
                </Nav.Link>
              )}

              {/* 구분선 */}
              <div
                className="d-none d-lg-block"
                style={{
                  width: "1px",
                  height: "24px",
                  backgroundColor: "rgba(255,255,255,0.3)",
                  margin: "0 16px",
                }}
              ></div>

              {/* 로그인/로그아웃 버튼 */}
              <div className="d-flex align-items-center flex-nowrap">
                {isAuthenticated ? (
                  <>
                    <span
                      className="text-white me-2"
                      style={{ fontSize: "0.82rem", whiteSpace: "nowrap", maxWidth: "110px", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                      {username
                        ? `${/^\d+$/.test(username) ? "사용자" : username}님`
                        : "환영합니다"}
                    </span>
                    <Button
                      variant="outline-light"
                      size="sm"
                      onClick={handleLogout}
                      className="px-2"
                      style={{ borderRadius: "100px", fontSize: "0.8rem", whiteSpace: "nowrap" }}
                    >
                      로그아웃
                    </Button>
                  </>
                ) : (
                  <div className="d-flex flex-nowrap">
                    <Button
                      as={Link}
                      to="/login"
                      variant="outline-light"
                      size="sm"
                      onClick={handleNavClick}
                      className="px-3 me-2"
                      style={{ borderRadius: "100px", fontSize: "0.82rem", whiteSpace: "nowrap" }}
                    >
                      로그인
                    </Button>
                    <Button
                      as={Link}
                      to="/register"
                      variant="light"
                      size="sm"
                      onClick={handleNavClick}
                      className="px-3"
                      style={{ color: "#009590", borderRadius: "100px", fontSize: "0.82rem", whiteSpace: "nowrap" }}
                    >
                      회원가입
                    </Button>
                  </div>
                )}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <style>{`
  /* 전체 네비바 한 줄 유지 */
  .navbar-collapse {
    flex-wrap: nowrap !important;
  }
  .navbar > .container,
  .navbar > .container-fluid {
    flex-wrap: nowrap !important;
  }

  /* 데스크탑 네비게이션 */
  .nav-link-custom::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 50%;
    background-color: white;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  .nav-link-custom:hover::after {
    width: 60%;
  }

  /* 모바일 메뉴 스타일링 */
  @media (max-width: 991.98px) {
    /* 햄버거 메뉴 여는 애니메이션 (선택 사항) */
    .navbar-collapse {
      transform: translateX(100%);
      transition: transform 0.3s ease;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 80%;
      height: 100%;
      background-color: #009590;
      z-index: 1030;
      overflow-y: auto;
      display: block !important;
      padding: 0;
    }
    
    .navbar-collapse.show {
      transform: translateX(0);
    }
    
    /* 모바일 메뉴 헤더 */
    .mobile-menu-header {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      margin-bottom: 8px;
    }
    
    /* 모바일 네비게이션 스타일 */
    .mobile-nav {
      display: flex;
      flex-direction: column;
      margin: 0 !important;
      padding: 0;
      width: 100%;
    }
    
    /* 모바일 메뉴 항목 스타일 */
    .mobile-menu-item {
      color: white;
      padding: 15px 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      font-weight: 400;
      font-size: 1rem;
      transition: background-color 0.2s;
    }
    
    .mobile-menu-item:hover, 
    .mobile-menu-item:active {
      background-color: rgba(255, 255, 255, 0.1);
      color: white;
    }
    
    /* 아이콘 컨테이너 */
    .menu-icon-container {
      position: relative;
      width: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    /* 장바구니 뱃지 */
    .mobile-menu-badge {
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 0.65rem;
      padding: 0.15rem 0.35rem;
      min-width: 1rem;
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 1px solid white;
    }
    
    /* 로그인/회원가입 섹션 */
    .mobile-auth-section {
      margin-top: 10px;
      border-top: 4px solid rgba(255, 255, 255, 0.1);
      padding-top: 10px;
    }
    
    /* 로그인/회원가입/로그아웃 버튼 */
    .login-item, .signup-item, .logout-item {
      font-weight: 500;
    }
    
    .signup-item {
      background-color: rgba(255, 255, 255, 0.9);
      color: #009590 !important;
      margin: 8px 20px;
      border-radius: 8px;
    }
    
    /* 사용자 인사말 */
    .user-greeting {
      font-size: 0.95rem;
    }
  }
`}</style>
    </header>
  );
};

const mapStateToProps = (state) => ({
  cartItemCount: state.cart.itemCount
});

const mapDispatchToProps = {
  updateCart
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
